export default "__VITE_ASSET__OGqcg6Lq__"